import * as React from 'react';
import { InlineChildren } from '@doordash/design-language';
import DashPassStrings from './DashPassStrings';
import InfoBanner, { BannerType } from '../Common/InfoBanner';
import { WrappedLink } from '../NavButton';
import { HELP_URL } from '../../constants/values';
export var GenericErrorBanner = function () {
    return (React.createElement(InfoBanner, { justification: InlineChildren.Justification.FlexStart, bannerType: BannerType.ERROR, bannerText: React.createElement("span", null,
            DashPassStrings.errorBannerMessagePart1(),
            ' ',
            React.createElement(WrappedLink, { target: "_blank", href: HELP_URL }, DashPassStrings.errorBannerMessagePart2()),
            ' ',
            DashPassStrings.errorBannerMessagePart3()), bannerTitle: DashPassStrings.errorBannerTitle() }));
};
export default GenericErrorBanner;
